"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.parse-int.js");

var _halfCircleSpinner = _interopRequireDefault(require("./half-circle-spinner"));

var _locale = _interopRequireDefault(require("sk-ui/lib/mixins/locale"));

var _popup = require("element-ui/lib/utils/popup");

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('transition', {
    attrs: {
      "name": "sk-loading-fade"
    },
    on: {
      "after-leave": _vm.handleAfterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "sk-loading-mask",
    "class": [_vm.customClass, {
      'is-fullscreen': _vm.fullscreen
    }],
    style: {
      backgroundColor: _vm.background || '',
      zIndex: 0
    },
    attrs: {}
  }, [_c('div', {
    staticClass: "sk-loading-spinner",
    attrs: {}
  }, [!_vm.action && !_vm.spinner ? _c('sk-half-circle-spinner', {
    staticStyle: {
      "margin-right": "1.25rem"
    },
    attrs: {
      "animation-duration": 1000,
      "color": "#409EFF"
    }
  }) : [!_vm.action ? [_c('i', {
    "class": _vm.spinner,
    attrs: {}
  }), _vm._v(" "), _vm.text ? _c('p', {
    staticClass: "sk-loading-text",
    attrs: {}
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()] : _c('span', {
    staticClass: "sk-loading-spinner__box",
    attrs: {}
  }, [_c('sk-half-circle-spinner', {
    staticStyle: {
      "margin-right": "0.5rem"
    },
    attrs: {
      "animation-duration": 1000,
      "color": "#409EFF"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sk-loading-text",
    attrs: {}
  }, [_vm._v(_vm._s(_vm.text || _vm.t('sk.ing')))])], 1)]], 2)])]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  mixins: [_locale["default"]],
  components: (0, _defineProperty2["default"])({}, _halfCircleSpinner["default"].name, _halfCircleSpinner["default"]),
  data: function data() {
    return {
      text: null,
      spinner: null,
      background: null,
      fullscreen: true,
      visible: false,
      customClass: '',
      action: false
    };
  },
  methods: {
    handleAfterLeave: function handleAfterLeave() {
      this.$emit('after-leave');
    },
    setText: function setText(text) {
      this.text = text;
    }
  },
  watch: {
    visible: function visible(val) {
      if (val === true && parseInt(this.$el.style.zIndex, 10) < _popup.PopupManager.zIndex) {
        this.$el.style.zIndex = _popup.PopupManager.nextZIndex();
      }
    }
  }
};
exports["default"] = _default;